export const DEFAULT_ISO_LOCALE = 'en-US';
export const DEFAULT_SES_LOCALE = 'en';
